import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import axios from 'axios';
import moment from 'moment';

import TableHeader from './components/TableHeader';
import TableRow from './components/TableRow';
import TableCell from './components/TableCell';
import Snapshot from './components/Snapshot';
import Schedule from './components/Schedule';

import { determineStatus } from '../../lib/utils';

export default class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      campaigns: [],
    };
  }

  componentDidMount() {
    this.refreshCampaigns();
  }

  refreshCampaigns = () => {
    const endpoint = '/api/ads';
    axios.get(endpoint)
      .then((res) => {
        if (res.status === 200 && res.data.ads) {
          const { ads } = res.data;
          this.setState({ campaigns: ads });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onPreview = (adId) => {
    const { history } = this.props;

    return () => {
      const url = `/preview/${adId}`;
      history.push(url);
    };
  }

  /* eslint-disable-next-line */
  onCancel = (adId) => {
    return () => {
      /* eslint-disable-next-line */
      const ok = confirm('Are you sure you want to cancel this campaign?');

      if (ok) {
        const endpoint = '/api/ad-cancel';
        axios.post(endpoint, {
          adId,
        }).then((res) => {
            if (res.status === 200) {
              this.refreshCampaigns();
            } else {
              /* eslint-disable-next-line */
              alert('Error encountered');
            }
          })
          .catch((err) => {
            /* eslint-disable-next-line */
            console.log(err);
            /* eslint-disable-next-line */
            alert('Error encountered');
          });
      }

      // console.log('nope');
    };
  }

  render() {
    const { campaigns } = this.state;

    const modifiedCampaigns = determineStatus(campaigns).map(c => Object.assign(c, c.model));
    const validCampaigns = modifiedCampaigns.filter(c => c.status === 'approved' || c.status === 'pending').filter(c => moment.utc(c.endDate).diff(moment.utc()) >= 0);
    const invalidCampaigns = modifiedCampaigns.filter(c => c.status !== 'approved' && c.status !== 'created' && c.status !== 'pending');

    return (
      <Container>
        <Section style={{ marginBottom: 60 }}>
          <ScheduleContainer>
            <Title style={{ marginBottom: 20 }}>SCHEDULE</Title>
            <Schedule
              campaigns={validCampaigns}
            />
          </ScheduleContainer>
          <SnapshotContainer>
            <Title>CURRENT SNAPSHOT</Title>
            <Snapshot
              campaigns={validCampaigns}
              onPreview={this.onPreview}
            />
          </SnapshotContainer>
        </Section>
        <Section style={{ flexDirection: 'column', marginBottom: 60 }}>
          <CampaignContainer>
            <Title>LIVE / UPCOMING</Title>
            {validCampaigns.length > 0 ? (
              <div>
                <TableHeader />
                {validCampaigns.map(campaign => (
                  <TableRow
                    campaign={campaign}
                    onPreview={this.onPreview(campaign.id)}
                    onCancel={this.onCancel(campaign.id)}
                  />
                ))}
              </div>
            ) : (
              <TableCell style={{ fontSize: 12, textAlign: 'center' }}>NO CAMPAIGNS</TableCell>
            )}
          </CampaignContainer>
        </Section>
        <Section style={{ flexDirection: 'column', marginBottom: 100 }}>
          <CampaignContainer>
            <Title>HISTORY</Title>
            {invalidCampaigns.length > 0 ? (
              <div>
                <TableHeader disableCancel />
                {invalidCampaigns.map(campaign => (
                  <TableRow
                    campaign={campaign}
                    onPreview={this.onPreview(campaign.id)}
                    onCancel={this.onCancel(campaign.id)}
                    disableCancel
                  />
                ))}
              </div>
            ) : (
              <TableCell style={{ fontSize: 12, textAlign: 'center' }}>NO CAMPAIGNS</TableCell>
            )}
          </CampaignContainer>
        </Section>
      </Container>
    );
  }
}

Dashboard.propTypes = {
  history: PropTypes.objectOf({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const Container = styled.div`
  max-width: 1600px;
  padding: 0 50px;
  margin: auto;
`;

const Section = styled.div`
  display: flex;
  flex-direction: row;
`;

const ScheduleContainer = styled.div`
  flex: 3;
`;

const SnapshotContainer = styled.div`
  flex: 2;
  margin-left: 50px;
`;

const Title = styled.div`
  font-family: 'Karla', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #5d81ec;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
`;

const CampaignContainer = styled.div``;




// WEBPACK FOOTER //
// ./client/Dashboard/index.js